import React, { createRef, Component, Fragment } from "react";
import axios from "axios";
import { axiosConfig, ValidateEmail, normalize } from "../../../config/utility";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import CreateIcon from "@material-ui/icons/Create";
import { connect } from "react-redux";

import { addSettings } from "../../../actions";
import {
  addNewSubAgent,
  getMainAgentInfo,
  getAddSubAgentEmailPreview,
} from "./../../../config/api_calls";
import { getCustomSettings } from "./../../../config/reseller_api_calls";
import $ from "jquery";
import DataTable from "../../../components/Tables/DataTable";
import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "./../../../config/helperClass";
import { THEME_TEXT_COLOR, THEME_COLOR } from "./../../../config/config";
import TextField from "../../../components/InputFields/TextField";
import SelectField from "../../../components/InputFields/SelectField";
import MutextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import HomeIcon from "@material-ui/icons/Home";
import StepWizard from "react-step-wizard";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/build/index.css";
import Select from "react-select";
import countryList from "react-select-country-list";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { PhoneNumberUtil } from "google-libphonenumber";

import PasswordStrengthBar from "react-password-strength-bar";

const auth = new HelperClass();

class Addclient extends Component {
  constructor() {
    super();
    this.state = {
      serviceData: [],
      select_service: "",
      errorMessage: "",
      serviceId: "",
      title: "",
      name: "",
      logo: "",
      agent_email: "",
      agent_phone: "",
      agent_company: "",
      agent_password: "",
      c_password: "",
      agent_address: "",
      agent_address2: "",
      agent_city: "",
      agent_state: "",
      agent_zip: "",
      agent_country: "United States",
      description: "",
      successMessage: "",
      tableLoader: true,
      domain: "",
      step: 1,
      dnsList: [],
      a_ip: "",
      is_verified: 0,
      AgentsList: [],
      select_agent: "",
      notifyCheckBox: false,
      account_status: "",
      passwordShown: false,
      confirmPasswordShown: false,
      errorSelectAgent: "",
      errorName: "",
      errorAgentStatus: "",
      errorAgentCompany: "",
      errorAgentEmail: "",
      errorAgentPhone: "",
      errorAgentAddress: "",
      errorAgentCity: "",
      errorAgentState: "",
      errorAgentZip: "",
      errorClientCountry: "",
      errorAgentPassword: "",
      errorCPassword: "",
      useGooglePlaces: true,
      toggleButtonText: "Allow PO Box Address",
      passwordRequired: false,
      main_agent_name: "",
      agent_id: "",
      address_autocomplete: true,
      address_validation: true,
    };
    this.countryOptions = countryList()
      .getData()
      .filter(country => country.label !== "United States Minor Outlying Islands")
      .sort((a, b) => {
        if (a.label === "United States") return -1;
        if (b.label === "United States") return 1;
        return a.label.localeCompare(b.label);
      });
    this.phoneInputRef = createRef();
  }

  phoneUtil = PhoneNumberUtil.getInstance();

  isPhoneValid = (phone) => {
    try {
      return this.phoneUtil.isValidNumber(
        this.phoneUtil.parseAndKeepRawInput(phone),
      );
    } catch (error) {
      return false;
    }
  };

  viewBtns = () => {
    if (
      this.props.is_msa_signed === "No" ||
      this.props.defaultSettings === "missing"
    ) {
      return <VisibilityOffIcon />;
    } else {
      return <VisibilityIcon style={{ cursor: "pointer" }} />;
    }
  };

  serviceSigning = async (value, tableMeta) => {
    //console.log("tableMeta.rowData: ", tableMeta.rowData[6]);
  };

  handleToggle = () => {
    this.setState((prevState) => ({
      useGooglePlaces: !prevState.useGooglePlaces,
      toggleButtonText:
        prevState.toggleButtonText === "Allow PO Box Address"
          ? "Allow Simple Address"
          : "Allow PO Box Address",
    }));
  };

  togglePassword = () => {
    this.setState({
      passwordShown: !this.state.passwordShown,
    });
  };

  toggleConfirmPassword = () => {
    this.setState({
      confirmPasswordShown: !this.state.confirmPasswordShown,
    });
  };

  async componentDidMount() {
    const { agent_id } = this.props.props.match.params;
    //console.log("agent_id: ", agent_id);

    this.setState({
      agent_id: agent_id,
    });
    const clientsResponce = await getMainAgentInfo(
      auth.getAccount(),
      auth.getToken(),
      agent_id,
    );

    //console.log("Client Data: ", clientsResponce.data);
    if (
      clientsResponce.data.status === 403 ||
      clientsResponce.data.errors === "authentication missing" ||
      clientsResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      clientsResponce.data.status === 404 ||
      clientsResponce.data.note === "missing"
    ) {
      // window.location.replace("/error");
      //console.log("settings missing");
      this.setState({
        tableLoader: false,
      });
    } else if (
      clientsResponce.data.status === 200 &&
      clientsResponce.data.message === "success"
    ) {
      this.setState({
        main_agent_name: clientsResponce.data.mainClientInfo.name,
        tableLoader: false,
      });
    } else {
      this.setState({
        tableLoader: false,
      });
      // window.location.replace("/error");
    }
    this.getCustomSettings();
  }

  handleFocus = () => {
    // Move cursor to the end of the input value
    const input = this.phoneInputRef.current;
    if (input) {
      const value = input.value;
      input.setSelectionRange(value.length, value.length);
    }
  };

  handleAddressSelect = async (place) => {
    const { description } = place.value;
    //console.log("dczdczxcxzcxzc");
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          description,
        )}&key=${process.env.REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY}`,
      );
      const data = await response.json();

      //console.log("handleAddressSelect: ", data);
      if (data.status === "OK") {
        const addressComponents = data.results[0].address_components;
        const formattedAddress = data.results[0].formatted_address;
        //console.log("addressComponents: ", data.results);
        let city = null;
        let state = null;
        let country = null;
        let zipCode = null;
        let streetAddress = "";
        let neighborhood = null;
        let locality = null;
        let address2 = "";
        addressComponents.forEach((component) => {
          if (component.types.includes("neighborhood")) {
            neighborhood = component.long_name;
          } else if (component.types.includes("locality")) {
            locality = component.long_name;
          } else if (component.types.includes("administrative_area_level_1")) {
            state = component.short_name;
          } else if (component.types.includes("country")) {
            country = component.long_name;
          } else if (component.types.includes("postal_code")) {
            zipCode = component.long_name;
          } else if (component.types.includes("subpremise")) {
            address2 = component.long_name;
          } else if (
            ![
              "neighborhood",
              "sublocality",
              "sublocality_level_1",
              "sublocality_level_2",
              "administrative_area_level_2",
              "administrative_area_level_3",
              "postal_code_suffix",
            ].includes(component.types[0])
          ) {
            if (streetAddress !== "") {
              streetAddress += " ";
            }
            streetAddress += component.long_name;
          }
        });
        // Check if neighborhood is part of the formatted address
        if (neighborhood && formattedAddress.includes(neighborhood)) {
          city = neighborhood;
        } else {
          city = locality;
        }
        this.setState({
          agent_city: city && city !== "" ? city : "",
          agent_state: state && state !== "" ? state : "",
          agent_zip: zipCode && zipCode !== "" ? zipCode : "",
          agent_country: country && country !== "" ? country : "",
          agent_address:
            streetAddress && streetAddress !== "" ? streetAddress : "",
          agent_address2: address2 && address2 !== "" ? address2 : "",
        });
      } else {
        console.error("Reverse geocoding request failed:", data.status);
      }
    } catch (error) {
      console.error("Error fetching reverse geocoding data:", error);
    }
  };

  handleChangeCountry = (event) => {
    //console.log("event.label: ", event.label);
    const country = event.label;
    this.setState({
      agent_country: country,
    });
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  handleChange = (event) => {
    const { target } = event;
    let value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;
    if (name === "name") {
      value = value.replace(/[^a-zA-Z\s'.,\-:()|!@]/g, "");
    } else if (name === "title") {
      value = value.replace(/[^a-zA-Z0-9\s_\-.,&:()|!@]/g, "");
    } else if (name === "agent_company") {
      value = value.replace(/[^a-zA-Z0-9\s_\-.,&:()|!@]/g, "");
    }
    this.setState({
      [name]: value,
    });
  };

  handleChangeStep = (input) => (e) => {
    this.setState({ [input]: e.target.value });
  };

  handleChangeFile = async (event) => {
    this.setState({
      rate_deck_file: event.target.files[0],
    });
    //await this.sendFileData(event.target.files[0]);
  };

  modalHide = () => {
    window.$("#modalAlert").modal("hide");
    // this.props.agreementSigned();
  };

  checkNumber = async (evt) => {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    var keyCode = key;
    key = String.fromCharCode(key);
    if (key.length == 0) return;
    var regex = /^[0-9.\b]+$/;
    if (keyCode == 188 || keyCode == 190) {
      return;
    } else {
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }
  };

  nextStep = () => {
    const { step } = this.state;

    this.setState({
      step: step + 1,
    });
    //console.log("STEP: ", this.state.step);
  };

  // Go to prev step
  prevStep = () => {
    const { step } = this.state;
    this.setState({
      step: step - 1,
    });
  };
  firstStep = () => {
    this.setState({
      step: 1,
    });
  };

  formClientUpdate = async () => {
    let {
      title,
      name,
      agent_email,
      agent_password,
      c_password,
      agent_phone,
      agent_company,
      agent_address,
      agent_address2,
      agent_city,
      agent_state,
      agent_zip,
      agent_country,
      select_agent,
      account_status,
    } = this.state;
    this.setState({
      successMessage: "",
      errorMessage: "",
      errorSelectAgent: "",
      errorName: "",
      errorAgentStatus: "",
      errorAgentCompany: "",
      errorAgentEmail: "",
      errorAgentPhone: "",
      errorAgentAddress: "",
      errorAgentCity: "",
      errorAgentState: "",
      errorAgentZip: "",
      errorClientCountry: "",
      errorAgentPassword: "",
      errorCPassword: "",
      errorPass: "",
    });
    let is_validated = true;
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

    if (this.state.name === "") {
      this.setState({
        errorSelectAgent: "",
        errorName: "error",
        errorMessage: "ame is required.",
      });
      is_validated = false;
    } else if (this.state.account_status === "") {
      this.setState({
        errorName: "",
        errorAgentStatus: "error",
        errorMessage: "Account Status is required.",
      });
      is_validated = false;
    } else if (this.state.agent_company === "") {
      this.setState({
        errorAccountStatus: "",
        errorAgentCompany: "error",
        errorMessage: "Company name is required.",
      });
      is_validated = false;
    } else if (this.state.agent_email === "") {
      this.setState({
        errorAgentCompany: "",
        errorAgentEmail: "error",
        errorMessage: "Email address is required.",
      });
      is_validated = false;
    } else if (ValidateEmail(this.state.agent_email) === false) {
      this.setState({
        errorAgentCompany: "",
        errorAgentEmail: "error",
        errorMessage: "Invalid email format.",
      });
      is_validated = false;
    } else if (this.state.agent_phone === "") {
      this.setState({
        errorAgentEmail: "",
        errorAgentPhone: "error",
        errorMessage: "Phone is required.",
      });
      is_validated = false;
    } else if (!this.isPhoneValid(agent_phone)) {
      this.setState({
        errorAgentEmail: "",
        errorAgentPhone: "error",
        errorMessage: "Invalid phone number.",
      });
      return false;
    } else if (this.state.agent_address === "") {
      this.setState({
        errorAgentPhone: "",
        errorAgentAddress: "error",
        errorMessage: "Address is required.",
      });
      is_validated = false;
    } else if (this.state.agent_city === "") {
      this.setState({
        errorAgentAddress: "",
        errorAgentCity: "error",
        errorMessage: "City is required.",
      });
      is_validated = false;
    } else if (this.state.agent_state === "") {
      this.setState({
        errorAgentCity: "",
        errorAgentState: "error",
        errorMessage: "State is required.",
      });
      is_validated = false;
    } else if (this.state.agent_zip === "") {
      this.setState({
        errorAgentState: "",
        errorAgentZip: "error",
        errorMessage: "Zip/postal code is required.",
      });
      is_validated = false;
    } else if (!this.state.agent_country || this.state.agent_country === "") {
      this.setState({
        errorAgentZip: "",
        errorClientCountry: "error",
        errorMessage: "Country is required.",
      });
      is_validated = false;
    } else if (
      this.state.passwordRequired &&
      this.state.agent_password === ""
    ) {
      this.setState({
        errorClientCountry: "",
        errorAgentPassword: "error",
        errorMessage: "Password is required.",
      });
      is_validated = false;
    } else if (
      this.state.passwordRequired &&
      this.state.agent_password !== ""
    ) {
      if (this.state.passwordRequired && this.state.agent_password.length < 8) {
        this.setState({
          errorClientCountry: "",
          errorAgentPassword: "error",
          errorMessage: "Use 8 characters or more for your password.",
        });
        is_validated = false;
      } else if (
        this.state.passwordRequired &&
        !passwordRegex.test(agent_password)
      ) {
        this.setState({
          errorClientCountry: "",
          errorAgentPassword: "error",
          errorMessage:
            "Password must be at least 8 characters, with uppercase, lowercase, number & special character.",
        });
        is_validated = false;
      } else if (this.state.passwordRequired && this.state.c_password === "") {
        this.setState({
          errorAgentPassword: "",
          errorCPassword: "error",
          errorMessage: "Confirm password is required.",
        });
        is_validated = false;
      } else if (
        this.state.passwordRequired &&
        this.state.c_password.length < 8
      ) {
        this.setState({
          errorAgentPassword: "",
          errorCPassword: "error",
          errorMessage: "Use 8 characters or more for your confirm password.",
        });
        is_validated = false;
      } else if (
        this.state.agent_password.trim() != this.state.c_password.trim()
      ) {
        this.setState({
          errorAgentPassword: "",
          errorCPassword: "error",
          errorMessage: "Password and confirm password does not match.",
        });
        is_validated = false;
      }
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    if (is_validated) {
      let apiResponce = await addNewSubAgent(
        auth.getAccount(),
        auth.getToken(),
        title,
        name,
        agent_email,
        agent_password,
        agent_phone,
        agent_company,
        agent_address,
        agent_address2,
        agent_city,
        agent_state,
        agent_zip,
        agent_country,
        this.state.notifyCheckBox.toString(),
        account_status,
        this.state.passwordRequired.toString(),
        this.state.agent_id,
      );
      //console.log("Add Client Response: ", apiResponce.data);
      if (
        apiResponce.data.status === 403 ||
        apiResponce.data.errors === "authentication missing" ||
        apiResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        apiResponce.data.status === 409 &&
        apiResponce.data.message === "Address validation failed"
      ) {
        const formattedErrorMessage = apiResponce.data.errors
          ? String(apiResponce.data.errors).replace(/,/g, "<br />")
          : "Address validation failed";

        this.setState({
          errorMessage: formattedErrorMessage,
          tableLoader: false,
        });
      } else if (
        apiResponce.data.status === 200 &&
        apiResponce.data.message === "success"
      ) {
        this.setState({
          successMessage: "Sub User added successfully.",
          tableLoader: false,
        });
        setTimeout(() => {
          window.history.back();
        }, 3000);
      } else if (
        apiResponce.data.status === 405 &&
        apiResponce.data.message === "email_exists"
      ) {
        this.setState({
          errorMessage:
            "Email already exists. Please try different email address.",
          disabled: false,
          tableLoader: false,
        });
        return false;
      } else {
        this.setState({
          errorMessage: "Something went wrong,try again later.",
          disabled: false,
          tableLoader: false,
        });
        //auth.logout();
      }
    }
  };

  onFileChange = (event) => {
    // Update the state
    this.setState({ logo: event.target.files[0] });
  };

  preViewDefault = async () => {
    const getEmailResponse = await getAddSubAgentEmailPreview(
      auth.getAccount(),
      auth.getToken(),
    );
    //console.log("getEmailResponse: ", getEmailResponse.data);
    if (
      getEmailResponse.data.status === 403 ||
      getEmailResponse.data.errors === "authentication missing" ||
      getEmailResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (getEmailResponse.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      getEmailResponse.data.status === 200 &&
      getEmailResponse.data.message === "success"
    ) {
      let emailTemplate = getEmailResponse.data.data[0][3];
      let logoUrl = getEmailResponse.data.data[0]["reseller_logo"];

      if (emailTemplate && emailTemplate !== "") {
        // Replace company logo
        emailTemplate = emailTemplate.replace(/{{comp_logo}}/g, logoUrl);

        // Replace placeholders with user input values
        emailTemplate = emailTemplate.replace(
          /{{client_name}}/g,
          this.state.name || "{{client_name}}",
        );
        emailTemplate = emailTemplate.replace(
          /{{comp_name}}/g,
          auth.getCompName() || "{{comp_name}}",
        );
        emailTemplate = emailTemplate.replace(
          /{{client_company}}/g,
          this.state.agent_company || "{{client_company}}",
        );
        emailTemplate = emailTemplate.replace(
          /{{client_email}}/g,
          this.state.agent_email || "{{client_email}}",
        );

        // Clean up any empty paragraphs
        emailTemplate = emailTemplate.replace(/<p>&nbsp;<\/p>/g, "");
      }

      this.setState({
        email_id: getEmailResponse.data.data[0][0],
        email_title: getEmailResponse.data.data[0][1],
        email_subject: getEmailResponse.data.data[0][2],
        email_template: emailTemplate,
        tableLoader: false,
        isEditorReady: true,
      });
      window.$("#modalPreviewDefaultModal").modal("show");
    } else {
      //window.location.replace("/error");
    }
  };

  closePreviewModal = () => {
    // Close the preview modal
    window.$("#modalPreviewDefaultModal").modal("hide");
  };

  getCustomSettings = async () => {
    try {
      const getCustomSetting_res = await getCustomSettings(
        auth.getAccount(),
        auth.getToken(),
      );
      //console.log("getCustomSetting_res: ", getCustomSetting_res.data);
      if (
        getCustomSetting_res.data.status === 200 &&
        getCustomSetting_res.data.data &&
        getCustomSetting_res.data.data.length > 0
      ) {
        this.setState({
          address_autocomplete:
            getCustomSetting_res.data.data[0].address_autocomplete || "Yes",
          address_validation:
            getCustomSetting_res.data.data[0].address_validation || "Yes",
        });
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };

  render() {
    const { useGooglePlaces, toggleButtonText } = this.state;
    const errorStyle = this.state.errorAgentAddress
      ? {
        input: (provided) => ({
          ...provided,
          borderColor: "red",
        }),
        control: (provided) => ({
          ...provided,
          borderColor: "red",
        }),
      }
      : {};
    return (
      <div className="nk-content " id="">
        <div className="container-fluid">
          {this.props.defaultSettings === "missing" ? <SettingsError /> : null}
          {/* MSA WARNING  START*/}
          {this.props.is_msa_signed === "No" ? <MsaWarning /> : null}

          {/* MSA WARNING END */}
          <div className="nk-block-head nk-block-head-sm">
            <div className="nk-block-between">
              <div className="nk-block-head-content">
                <Breadcrumbs aria-label="breadcrumb">
                  <Link
                    color="inherit"
                    onClick={() => this.addMenuHistory("/")}
                    className=""
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <HomeIcon fontSize="inherit" className="" />
                    Home
                  </Link>
                  <Link
                    color="inherit"
                    onClick={() => this.addMenuHistory("/agents")}
                    className=""
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    Partners
                  </Link>
                  <Typography color="textPrimary" className="">
                    Add New Sub User
                  </Typography>
                </Breadcrumbs>
                {/*<h3 className="nk-block-title page-title">
                  <PageTitle name="Add New Services" />
                </h3>*/}
              </div>
            </div>
          </div>
          <div className="row g-4">
            <div className="col-md-12">
              <div className="card card-bordered">
                <div className="card-inner">
                  <div className="card-head">
                    <h6 className="card-title">
                      Register {auth.getCompName()} sub user account.
                    </h6>
                  </div>
                  {this.state.errorMessage !== "" ? (
                    <div className="example-alert">
                      <div className="alert alert-pro alert-danger">
                        <div className="alert-text">
                          <h4>Error</h4>
                          <p
                            dangerouslySetInnerHTML={{
                              __html: this.state.errorMessage,
                            }}
                          ></p>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {this.state.successMessage !== "" ? (
                    <div className="example-alert">
                      <div className="alert alert-pro alert-success">
                        <div className="alert-text">
                          <h4>Success</h4>
                          <p>{this.state.successMessage}</p>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <br />
                  <form
                    method="post"
                    encType="multipart/form-data"
                    autoComplete="off" role="presentation"
                  >
                    <div className="row g-4">
                      <div className="form-group col-md-6">
                        <MutextField
                          required
                          id="main_agent_name"
                          name="main_agent_name"
                          type="text"
                          label="Main Partner"
                          value={this.state.main_agent_name}
                          inputProps={{ maxLength: 64, readOnly: true }}
                          helperText="Main Partner of the invite recipient."
                          variant="outlined"
                          disabled
                          fullWidth
                        autoComplete="new-password"
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <MutextField
                          required
                          id="name"
                          name="name"
                          type="text"
                          label="Full Name"
                          inputProps={{ maxLength: 50 }}
                          value={this.state.name}
                          onChange={this.handleChange}
                          helperText="Enter the name. Allowed characters: (&nbsp; ' &nbsp; - &nbsp; . &nbsp; , &nbsp; : &nbsp; ( ) &nbsp; | &nbsp; ! &nbsp; @ )"
                          variant="outlined"
                          fullWidth
                          error={this.state.errorName === "error"}
                        autoComplete="new-password"
                        />
                      </div>
                      <div className="form-group col-md-3">
                        <MutextField
                          id="title"
                          name="title"
                          type="text"
                          inputProps={{ maxLength: 30 }}
                          label="Title"
                          value={this.state.title}
                          onChange={this.handleChange}
                          helperText="Enter the title. Allowed characters: (&nbsp; _ &nbsp; - &nbsp; . &nbsp; &amp; &nbsp; , &nbsp; : &nbsp; ( ) &nbsp; | &nbsp; ! &nbsp; @ )"
                          variant="outlined"
                          fullWidth
                        autoComplete="new-password"
                        />
                      </div>
                      <div className="form-group col-md-3">
                        <MutextField
                          id="account_status"
                          name="account_status"
                          select
                          label="Select Account Status"
                          value={this.state.account_status}
                          onChange={this.handleChange}
                          SelectProps={{
                            native: true,
                          }}
                          helperText="Select the account status here."
                          variant="outlined"
                          fullWidth
                          error={this.state.errorAgentStatus === "error"}
                        autoComplete="new-password"
                        >
                          <option key="" value=""></option>
                          <option key="5" value="active">
                            Active
                          </option>
                          <option key="10" value="inactive">
                            Inactive
                          </option>
                        </MutextField>
                      </div>

                      <div className="form-group col-md-6">
                        <MutextField
                          required
                          id="agent_company"
                          name="agent_company"
                          type="text"
                          inputProps={{ maxLength: 100 }}
                          label="Company Name"
                          value={this.state.agent_company}
                          onChange={this.handleChange}
                          helperText="Enter the company name. Allowed characters: (&nbsp; _ &nbsp; . &nbsp; - &nbsp; , &nbsp; : &nbsp; &amp; &nbsp; ( ) &nbsp; | &nbsp; ! &nbsp; @ )"
                          variant="outlined"
                          fullWidth
                          error={this.state.errorAgentCompany === "error"}
                        autoComplete="new-password"
                        />
                      </div>

                      <div className="form-group col-md-6">
                        <MutextField
                          required
                          id="agent_email"
                          name="agent_email"
                          type="email"
                          label="Email Address"
                          defaultValue={this.state.agent_email}
                          onChange={this.handleChange}
                          helperText="Enter your email address here."
                          variant="outlined"
                          fullWidth
                          error={this.state.errorAgentEmail === "error"}
                        autoComplete="new-password"
                        />
                      </div>

                      <div className="form-group col-md-6">
                        <PhoneInput
                          required
                          defaultCountry={"us"}
                          inputProps={{
                            name: "agent_phone",
                            id: "agent_phone",
                            maxLength: 20,
                            style: this.state.errorAgentPhone
                              ? { borderColor: "red" }
                              : {},
                          }}
                          dialCodePreviewStyleProps={{
                            style: this.state.errorAgentPhone
                              ? { borderColor: "red" }
                              : {},
                          }}
                          value={this.state.agent_phone}
                          onChange={(value) =>
                            this.handleChange({
                              target: { name: "agent_phone", value },
                            })
                          }
                          helperText="Enter the phone number here."
                          label="Phone Number"
                          ref={this.phoneInputRef}
                          onFocus={this.handleFocus}
                        />
                      </div>

                      <div className="form-group col-md-6">
                        <div
                          className="nk-block-between-md"
                          style={{
                            position: "absolute",
                            zIndex: 9999,
                            right: "13px",
                            top: "-15px",
                          }}
                        >
                          <div className="nk-block-head-content">
                            <label
                              htmlFor="googleLocation-autocomplete"
                              style={{
                                color: "black",
                                fontWeight: "500",
                                marginBottom: "8px",
                              }}
                            >
                              {" "}
                            </label>
                          </div>
                          {this.state.address_autocomplete === "Yes" && (
                            <div className="nk-block-head-content">
                              <ul className="nk-block-tools gx-3">
                                <li>
                                  <a
                                    onClick={this.handleToggle}
                                    className="text-primary fs-11"
                                    style={{
                                      cursor: "pointer",
                                      fontSize: "11px",
                                    }}
                                  >
                                    {toggleButtonText}
                                  </a>
                                </li>
                              </ul>
                            </div>
                          )}
                        </div>
                        {this.state.address_autocomplete === "Yes" ? (
                          useGooglePlaces ? (
                            <GooglePlacesAutocomplete
                              apiKey={
                                process.env
                                  .REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY
                              }
                              apiOptions={{ loading: 'async' }}
                              selectProps={{
                                value: this.state.agent_address
                                  ? {
                                    label: this.state.agent_address,
                                    value: this.state.agent_address,
                                  }
                                  : null,
                                onChange: this.handleAddressSelect,
                                placeholder: this.state.agent_address
                                  ? null
                                  : "Enter your address..",
                                styles: {
                                  ...errorStyle,
                                  input: (provided) => ({
                                    ...provided,
                                    color: "black",
                                    height: "47px",
                                  }),
                                  option: (provided) => ({
                                    ...provided,
                                    color: "black",
                                  }),
                                  singleValue: (provided) => ({
                                    ...provided,
                                    color: "black",
                                  }),
                                  menu: (provided) => ({
                                    ...provided,
                                    zIndex: 9,
                                  }),
                                },
                              }}
                              className="googleLocation-autocomplete"
                            />
                          ) : (
                            <MutextField
                              required
                              id="agent_address"
                              name="agent_address"
                              type="text"
                              label="PO Box Address"
                              value={this.state.agent_address}
                              inputProps={{ maxLength: 100 }}
                              onChange={this.handleChange}
                              helperText="Enter valid PO Box Address. i.e, PO Box Number, City, State Zip Code"
                              variant="outlined"
                              fullWidth
                              error={this.state.errorAgentAddress === "error"}
                            autoComplete="new-password"
                            />
                          )
                        ) : (
                          // address_autocomplete === "No" → show PO Box only
                          <MutextField
                            required
                            id="agent_address"
                            name="agent_address"
                            type="text"
                            label="Address"
                            value={this.state.agent_address}
                            onChange={this.handleChange}
                            helperText="Enter your address"
                            variant="outlined"
                            fullWidth
                            error={this.state.errorAgentAddress === "error"}
                          autoComplete="new-password"
                          />
                        )}
                      </div>

                      <div className="form-group col-md-6">
                        <MutextField
                          id="agent_address2"
                          name="agent_address2"
                          type="text"
                          label="Address 2"
                          value={this.state.agent_address2}
                          onChange={this.handleChange}
                          inputProps={{ maxLength: 100 }}
                          helperText="If needed, enter additional address details, such as apartment number, suite, or unit."
                          variant="outlined"
                          fullWidth
                        autoComplete="new-password"
                        />
                      </div>

                      <div
                        className="form-group col-md-2"
                        style={{ marginBottom: "0px" }}
                      >
                        <MutextField
                          required
                          id="agent_city"
                          name="agent_city"
                          type="text"
                          label="City"
                          value={this.state.agent_city}
                          inputProps={{ maxLength: 32 }}
                          onChange={this.handleChange}
                          helperText=""
                          variant="outlined"
                          fullWidth
                          error={this.state.errorAgentCity === "error"}
                        autoComplete="new-password"
                        />
                      </div>
                      <div
                        className="form-group col-md-2"
                        style={{ marginBottom: "0px" }}
                      >
                        <MutextField
                          required
                          id="agent_state"
                          name="agent_state"
                          type="text"
                          label="State"
                          value={this.state.agent_state}
                          inputProps={{ maxLength: 32 }}
                          onChange={this.handleChange}
                          helperText=""
                          variant="outlined"
                          fullWidth
                          error={this.state.errorAgentState === "error"}
                        autoComplete="new-password"
                        />
                      </div>
                      <div
                        className="form-group col-md-2"
                        style={{ marginBottom: "0px" }}
                      >
                        <MutextField
                          required
                          id="agent_zip"
                          name="agent_zip"
                          type="text"
                          label="Zip / Postal Code"
                          value={this.state.agent_zip}
                          inputProps={{ maxLength: 9 }}
                          onChange={this.handleChange}
                          helperText=""
                          variant="outlined"
                          fullWidth
                          error={this.state.errorAgentZip === "error"}
                        autoComplete="new-password"
                        />
                      </div>
                      <div
                        className="form-group col-md-6"
                        style={{ marginBottom: "0px" }}
                      >
                        <Select
                          id="agent_country"
                          className="customCountrySelect-addClient"
                          name="agent_country"
                          label="country"
                          options={this.countryOptions}
                          value={
                            this.state.agent_country
                              ? this.countryOptions.find(opt => opt.label === this.state.agent_country)
                              : null
                          }
                          onChange={this.handleChangeCountry}
                          styles={{
                            control: (provided) => ({
                              ...provided,
                              minHeight: "56px",
                            }),
                            menu: (provided, state) => ({
                              ...provided,
                              zIndex: 9,
                            }),
                          }}
                          placeholder="Select Country"
                        />
                        <p className="MuiFormHelperText-root MuiFormHelperText-contained Mui-required">
                          Select country
                        </p>
                      </div>
                      <div
                        className="custom-control custom-control-lg custom-checkbox col-lg-12"
                        style={{
                          padding: 0,
                          marginLeft: "3rem",
                          marginBottom: "1rem",
                        }}
                      >
                        <div className="form-group">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="customCheck3"
                            checked={this.state.passwordRequired}
                            onChange={() => {
                              const isChecked = !this.state.passwordRequired;
                              this.setState({
                                passwordRequired: isChecked,
                              });
                              //console.log("Required Password:", isChecked);
                            }}
                          />
                          <label
                            className="custom-control-label"
                            for="customCheck3"
                          >
                            Add Password
                          </label>
                        </div>
                      </div>

                      {this.state.passwordRequired && (
                        <>
                          <div
                            className="form-group col-md-6"
                            style={{ position: "relative" }}
                          >
                            <MutextField
                              required
                              id="agent_password"
                              name="agent_password"
                              type={
                                this.state.passwordShown ? "text" : "password"
                              }
                              label="Password"
                              defaultValue={this.state.agent_password}
                              inputProps={{ maxLength: 50 }}
                              onChange={this.handleChange}
                              helperText=""
                              variant="outlined"
                              fullWidth
                              error={this.state.errorAgentPassword === "error"}
                            autoComplete="new-password"
                            />
                            <a
                              style={{
                                left: "auto",
                                right: "10px",
                                top: "41px",
                                position: "absolute",
                                cursor: "pointer",
                              }}
                              tabIndex="-1"
                              onClick={this.togglePassword}
                              className="form-icon form-icon-right passcode-switch"
                              data-target="password"
                            >
                              {this.state.passwordShown ? (
                                <em className="icon ni ni-eye-off"></em>
                              ) : (
                                <em className="icon ni ni-eye"></em>
                              )}
                            </a>
                            <small
                              className="form-text"
                              style={{
                                position: "absolute",
                                top: "69px",
                                left: "26px",
                                color: "#0000008a",
                                fontSize: "0.75rem",
                                fontWeight: "400",
                                fontFamily:
                                  '"Roboto", "Helvetica", "Arial", sans-serif',
                              }}
                            >
                              Password must be at least 8 characters, with
                              uppercase, lowercase, number & special character.
                            </small>
                            <div style={{ marginTop: "30px" }}>
                              <PasswordStrengthBar
                                password={this.state.agent_password}
                              />
                            </div>
                          </div>
                          <div
                            className="form-group col-md-6"
                            style={{ position: "relative" }}
                          >
                            <MutextField
                              required
                              id="c_password"
                              name="c_password"
                              type={
                                this.state.confirmPasswordShown
                                  ? "text"
                                  : "password"
                              }
                              label="Confirm Password"
                              defaultValue={this.state.c_password}
                              inputProps={{ maxLength: 50 }}
                              onChange={this.handleChange}
                              helperText=""
                              variant="outlined"
                              fullWidth
                              error={this.state.errorCPassword === "error"}
                            autoComplete="new-password"
                            />
                            <a
                              style={{
                                left: "auto",
                                right: "10px",
                                top: "41px",
                                position: "absolute",
                                cursor: "pointer",
                              }}
                              tabIndex="-1"
                              onClick={this.toggleConfirmPassword}
                              className="form-icon form-icon-right passcode-switch"
                              data-target="password"
                            >
                              {this.state.confirmPasswordShown ? (
                                <em className="icon ni ni-eye-off"></em>
                              ) : (
                                <em className="icon ni ni-eye"></em>
                              )}
                            </a>
                            <small
                              className="form-text"
                              style={{
                                position: "absolute",
                                top: "69px",
                                left: "26px",
                                color: "#0000008a",
                                fontSize: "0.75rem",
                                fontWeight: "400",
                                fontFamily:
                                  '"Roboto", "Helvetica", "Arial", sans-serif',
                              }}
                            >
                              Confirm Password must be at least 8 characters,
                              with uppercase, lowercase, number & special
                              character. Confirm Password must match the
                              Password.
                            </small>
                          </div>
                        </>
                      )}
                      <div
                        className="custom-control custom-control-lg custom-checkbox col-lg-12"
                        style={{ padding: 0, marginLeft: "3rem" }}
                      >
                        <div className="form-group">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="customCheck2"
                            checked={this.state.notifyCheckBox}
                            onChange={() => {
                              const isChecked = !this.state.notifyCheckBox;
                              this.setState({ notifyCheckBox: isChecked });
                              // console.log(
                              //   "Notify Checkbox Checked:",
                              //   isChecked
                              // );
                            }}
                          />
                          <label
                            className="custom-control-label"
                            for="customCheck2"
                          >
                            Notify Sub User
                          </label>
                        </div>
                      </div>
                      <div
                        className="col-lg-12 no-padding-preview"
                        style={{
                          padding: 0,
                          cursor: "pointer",
                          color: "#0066cc",
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          this.preViewDefault();
                        }}
                      >
                        <span>Preview Notification Email </span>
                      </div>
                      <div style={{ clear: "both" }}></div>
                      <hr />
                      <div className="form-group text-right col-md-12">
                        <button
                          className="btn btn-lg btn-primary"
                          type="button"
                          disabled={this.state.disabled}
                          onClick={this.formClientUpdate}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>

                  <br />
                  <br />
                </div>
              </div>
              {/* PREVIEW DEFAULT MODAL  */}
              <div
                className="modal fade"
                tabIndex="-1"
                id="modalPreviewDefaultModal"
                style={{ zIndex: "9999" }}
              >
                <div
                  className="modal-dialog modal-xl modal-dialog-top"
                  role="document"
                >
                  <div className="modal-content">
                    <div
                      className="modal-header"
                      style={{ borderBottom: "1px solid #e5e9f2" }}
                    >
                      <h5
                        className="modal-title"
                        style={{
                          fontFamily: "'DM Sans', sans-serif",
                          fontWeight: "700",
                          fontSize: "1.25rem",
                          color: "#364a63",
                        }}
                      >
                        Preview Notification Email
                      </h5>
                      <a
                        style={{ cursor: "pointer" }}
                        className="close"
                        onClick={() => this.closePreviewModal()}
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                    </div>
                    <div className="modal-body" style={{ padding: "1.5rem" }}>
                      <div className="nk-block">
                        <div className="card card-bordered">
                          <div className="card-inner">
                            <div
                              className="email-preview"
                              style={{
                                maxHeight: "60vh",
                                overflow: "auto",
                                padding: "1rem",
                                backgroundColor: "#f5f6fa",
                                borderRadius: "4px",
                              }}
                            >
                              {this.state.isEditorReady ? (
                                <div>
                                  <style>
                                    {`
                                  .email-preview-content button,
                                  .email-preview-content a {
                                    pointer-events: none !important;
                                    cursor: not-allowed !important;
                                    text-decoration: none;
                                  }
                                `}
                                  </style>
                                  <div
                                    className="email-preview-content"
                                    style={{
                                      fontFamily: "'Roboto', sans-serif",
                                      fontSize: "14px",
                                      lineHeight: "1.65",
                                      pointerEvents: "none",
                                      userSelect: "none",
                                    }}
                                    dangerouslySetInnerHTML={{
                                      __html: this.state.email_template,
                                    }}
                                  />
                                </div>
                              ) : (
                                tableLoader()
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="modal-footer"
                      style={{
                        borderTop: "1px solid #e5e9f2",
                        padding: "1rem 1.5rem",
                      }}
                    >
                      <button
                        onClick={() => this.closePreviewModal()}
                        className="btn btn-primary"
                        style={{
                          fontFamily: "'DM Sans', sans-serif",
                          fontWeight: "500",
                        }}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* PREVIEW DEFAULT MODAL  */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Addclient);
